import type { FaireProductEntity } from "../../entity_types/product";

export const p_qrc4aaw3a2: FaireProductEntity = {
  token: "p_qrc4aaw3a2",
  type: "product",
  name: "Gold Virgin Mary Necklace, Religious Jewelry Satellite Chain",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/68bdcd8176e4ef85417071563037c6cba88bce7ad998df49d398e189c4b89d3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eee69b5221aea5d5020e1dd23c48d7d303085a082c89aff4c40c8023db3e1be2.jpeg",
    "https://cdn.faire.com/fastly/2638ac26713b795d552917d477f2a37d92b19a84877ec5b38a47573ed8781b5f.jpeg",
    "https://cdn.faire.com/fastly/856335a51222e71affc390efee79b49179b1d91efec5c27d5d5b3a3e48186a95.jpeg",
    "https://cdn.faire.com/fastly/cf9123d43ff157d319510547b8a7c7125f7423ca87f0ae52e8d2d4c70183447a.jpeg",
    "https://cdn.faire.com/fastly/a46364a94b9c4962c2f2809470d74a45def5cba1f0f0acd360dfa45a59d5c5da.jpeg",
    "https://cdn.faire.com/fastly/36cf421ebf81b0f4de9858e11f566e8a06051159e338f20722d294882d6d5c45.jpeg",
    "https://cdn.faire.com/fastly/4640aaacaeee7c9b5fd5e06008b94c697e7e0f0e049c8c4af6d0bc0a44618c56.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "14k gold plated satellite chain with 14k gold filled jumprings, and clasp. 14k gold plated medal\nSizes:\nThe small one is 1/2 of an inch(.5), medium one is 11x15mm and large one is 14x20mm.",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:40.853Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
